// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-card {
  margin-top: 1rem;
  border: none;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.event-card__image {
  display: block;
  width: 100%;
}
.event-card__image .event-image {
  border: none;
  border-radius: 0;
  box-shadow: none;
}

.card-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 12px;
  color: #6c757d;
}

.card-title {
  font-size: 1.35rem;
}

.description {
  color: #4a5568;
  margin: 8px 0 12px;
  line-height: 1.5;
}

.meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
  margin: 4px 0 4px;
}

.meta {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 10px;
  background: #f7f8fb;
  border-radius: 10px;
}

.meta fa-icon {
  margin-top: 2px;
  color: var(--e-global-color-primary);
}

.meta-label {
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.06em;
  color: #6c757d;
}

.meta-value {
  font-weight: 600;
  color: #1f2937;
}

.time-range {
  color: #4a5568;
}

.cta-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: auto;
}

@media (min-width: 768px) {
  .event-card {
    display: grid;
    grid-template-columns: minmax(220px, 320px) 1fr;
    gap: 16px;
  }
  .event-card__image {
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/event-list-item/event-list-item.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;AACF;AAAE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,oCAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACE,aAAA;IACA,+CAAA;IACA,SAAA;EACF;EAEA;IACE,YAAA;EAAF;AACF","sourcesContent":[".event-card {\n  margin-top: 1rem;\n  border: none;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.event-card__image {\n  display: block;\n  width: 100%;\n  .event-image {\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n.card-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: 100%;\n}\n\n.title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.eyebrow {\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.card-title {\n  font-size: 1.35rem;\n}\n\n.description {\n  color: #4a5568;\n  margin: 8px 0 12px;\n  line-height: 1.5;\n}\n\n.meta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 10px;\n  margin: 4px 0 4px;\n}\n\n.meta {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 10px;\n  background: #f7f8fb;\n  border-radius: 10px;\n}\n\n.meta fa-icon {\n  margin-top: 2px;\n  color: var(--e-global-color-primary);\n}\n\n.meta-label {\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n  color: #6c757d;\n}\n\n.meta-value {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.time-range {\n  color: #4a5568;\n}\n\n.cta-row {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: auto;\n}\n\n@media (min-width: 768px) {\n  .event-card {\n    display: grid;\n    grid-template-columns: minmax(220px, 320px) 1fr;\n    gap: 16px;\n  }\n\n  .event-card__image {\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
